// The organizer sentiment survey is live: sharing any key or constant with it
// would corrupt its state or wipe its eligibility.
export const WT_SURVEY_VERSION = 1;

// The campaign ends when the flag goes off, not on a date, so this record must
// outlive any TTL. Do not add one.
export const WT_SURVEY_LS_KEY = `wt_survey_v${WT_SURVEY_VERSION}`;

export const WT_SURVEY_BROADCAST_CHANNEL = 'wt_survey_v1';
export const WT_SURVEY_CLOSE_MESSAGE = 'closed';

// Tagging scheme not settled; append query params here when it is.
export const WT_SURVEY_TYPEFORM_URL = 'https://ms732111.typeform.com/to/l0tetvMh';

// PLACEHOLDER: a crop from the design mock, not the final asset. Swap the file
// at this path when the real WeTransfer illustration lands.
export const WT_SURVEY_ILLUSTRATION_SRC = '/wt-survey/illustration.png';

export const WT_SURVEY_DWELL_MS = 2500;

// These are indexed event pages, so an interstitial on them is an SEO risk.
export const WT_SURVEY_CRAWLER_UA_TOKENS = [
  'googlebot',
  'bingbot',
  'duckduckbot',
  'yandex',
  'baidu',
  'applebot',
  'bot',
  'crawler',
  'spider',
];

export const WT_SURVEY_EVENT_SHOWN = 'wt_survey_shown';
export const WT_SURVEY_EVENT_CLICKED = 'wt_survey_clicked';
export const WT_SURVEY_EVENT_DISMISSED = 'wt_survey_dismissed';

// EDS's ESC and backdrop handlers share one un-argumented onClose, so the
// component owns the close controls to report which path was taken.
export const WT_SURVEY_DISMISS_ACTIONS = {
  closeButton: 'close_button',
  escapeKey: 'escape_key',
  overlay: 'overlay',
} as const;

export type WtSurveyDismissAction = (typeof WT_SURVEY_DISMISS_ACTIONS)[keyof typeof WT_SURVEY_DISMISS_ACTIONS];
